import { render, staticRenderFns } from "./FormPerson.vue?vue&type=template&id=52b44f7e&scoped=true&"
import script from "./FormPerson.vue?vue&type=script&lang=js&"
export * from "./FormPerson.vue?vue&type=script&lang=js&"
import style0 from "./FormPerson.vue?vue&type=style&index=0&id=52b44f7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b44f7e",
  null
  
)

export default component.exports